import React, { ReactElement } from 'react';
import type { Route } from 'next';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import Link from 'next/link';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/Benefits/Networking/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[
            { title: 'Benefits', href: '/benefits' as Route },
            { title: 'Networking', href: '' as Route },
          ]}
        />
        <div className={cn('header__content')}>
          <div className={cn('header__title-box')}>
            <h1 className={cn('header__title')}>
              Freight Networking with DF Alliance
            </h1>
            {screenWidth >= 769
              ?
              <p className={cn('header__title-description')}>
                <span>Join a trusted network of freight forwarders across 190+ countries. Strengthen your</span>
                <span>global logistics network at DF Alliance with our global freight forwarding technology solutions that</span>
                <span>bring all forwarders together, enhances business growth,</span>
                <span>and expands reach worldwide.</span>
              </p>
              :
              <p className={cn('header__title-description')}>
                Join a trusted network of freight forwarders across 190+ countries. Strengthen your
                global logistics network at DF Alliance with our global
                freight forwarding technology solutions that
                bring all forwarders together, enhances business growth,
                and expands reach worldwide.
              </p>
            }
          </div>
          {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
          {/* <div className={cn('header__buttons')}>
            <Link className={cn('header__button-join')} href="/membership">
              Join Us
            </Link>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;